import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 960,
	height: 162,
	viewBox: "0 0 960 162",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 80,
			cy: 82,
			r: 80,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 240,
			cy: 82,
			r: 80,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 400,
			cy: 82,
			r: 80,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.696 56.304H88.328V115H71.696V56.304ZM46 49H114.024V63.696H46V49Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.04 99.712V86.336H262.624V99.712H217.04ZM251.008 47L281.456 113H263.768L237.632 53.952H242.736L216.688 113H199L229.448 47H251.008Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 560,
			cy: 82,
			r: 80,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M516 119.376V91.392H529.2L535.272 91.568H582L586.048 91.392H604.528V119.376H589.04V106H531.488V119.376H516ZM529.904 40H593.088V101.072H576.456V46.952L583.936 54.52H538.792L545.656 48.976C546.067 51.8507 546.301 54.6373 546.36 57.336C546.477 59.976 546.536 62.4987 546.536 64.904C546.536 71.944 545.949 77.8693 544.776 82.68C543.661 87.4907 541.931 91.1573 539.584 93.68C537.296 96.144 534.451 97.376 531.048 97.376L524.096 91.656C526.501 88.84 528.291 84.968 529.464 80.04C530.637 75.0533 531.224 68.8933 531.224 61.56C531.224 58.216 531.107 54.7547 530.872 51.176C530.637 47.5387 530.315 43.8133 529.904 40Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M366 47H382.632V113H366V47ZM418.448 47H434.992V113H418.448V47ZM375.24 72.256H425.488V86.864H375.24V72.256Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 720,
			cy: 82,
			r: 80,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M747.552 73.84V86.16H699.768V73.84H747.552ZM711.032 80L706.632 107.28L699.68 99.448H750.368V113H690L695.104 80L690 47H749.928V60.552H699.68L706.632 52.72L711.032 80Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 880,
			cy: 80,
			r: 80,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M927.6 49V115H911.76V54.808L915.632 55.072L888.792 115H871.808L844.968 55.248L848.84 54.896V115H833V49H858.608L883.688 106.728H877L901.992 49H927.6Z",
			fill: "white"
		})
	]
});
export default Svg;
